module.exports = __webpack_public_path__ + "static/media/jumbo4.beae5ad3.png";